// Maps the kids_plans.features JSON (e.g. {"games":true,"ai_mentor":false,...})
// into a readable list of the features a plan includes. Also tolerates the
// legacy shape where features was a plain array of strings.

export const KIDS_FEATURE_LABELS = {
  games:        "All learning games",
  ai_mentor:    "AI Mentor — Cabil Star",
  live_classes: "Live group classes",
  reports:      "Progress reports",
};

export function planFeatureList(plan) {
  if (!plan) return [];
  const f = plan.features;

  // Legacy: already an array of strings.
  if (Array.isArray(f)) return f;

  // Current: an object of { feature_key: bool }.
  if (f && typeof f === "object") {
    return Object.keys(KIDS_FEATURE_LABELS)
      .filter((k) => f[k])
      .map((k) => KIDS_FEATURE_LABELS[k]);
  }

  // String that might be JSON.
  if (typeof f === "string") {
    try { return planFeatureList({ features: JSON.parse(f) }); }
    catch { return []; }
  }

  return [];
}
